/**
=========================================================
* Material Dashboard 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Button Styles
import root from "../button/root";
import contained from "../button/contained";
import outlined from "../button/outlined";
import text from "../button/text";

export default {
  defaultProps: {
    disableRipple: false,
  },
  styleOverrides: {
    // MUI v9 removed the combined variant+size and variant+color slots
    // (containedPrimary, outlinedSizeSmall, ...). They are expressed as root
    // variants instead; the single-variant base slots stay as direct slots.
    root: {
      ...root,
      variants: [
        { props: { variant: "contained", size: "small" }, style: { ...contained.small } },
        { props: { variant: "contained", size: "large" }, style: { ...contained.large } },
        { props: { variant: "contained", color: "primary" }, style: { ...contained.primary } },
        { props: { variant: "contained", color: "secondary" }, style: { ...contained.secondary } },
        { props: { variant: "outlined", size: "small" }, style: { ...outlined.small } },
        { props: { variant: "outlined", size: "large" }, style: { ...outlined.large } },
        { props: { variant: "outlined", color: "primary" }, style: { ...outlined.primary } },
        { props: { variant: "outlined", color: "secondary" }, style: { ...outlined.secondary } },
        { props: { variant: "text", size: "small" }, style: { ...text.small } },
        { props: { variant: "text", size: "large" }, style: { ...text.large } },
        { props: { variant: "text", color: "primary" }, style: { ...text.primary } },
        { props: { variant: "text", color: "secondary" }, style: { ...text.secondary } },
      ],
    },
    contained: { ...contained.base },
    outlined: { ...outlined.base },
    text: { ...text.base },
  },
};
